import { ListItemText } from 'app/components/ChakraTableList';
import { LatestSplit, Member, SplitMemberStatus } from 'types/splits.types';
import { Button, Icon } from '@chakra-ui/react';
import { ReactComponent as CheckmarkIcon } from 'resources/images/checkmark.svg';
import { DataTestId } from 'types/general.types';

interface SplitStatusProps {
  proposeNewSplit?: () => void;
  acceptSplit?: () => void;
  split?: LatestSplit;
  currentUserGuid?: string;
  member: Member;
}

export const SplitStatus = ({
  acceptSplit,
  split,
  proposeNewSplit,
  member,
  currentUserGuid,
  'data-testid': dataTestId,
}: SplitStatusProps & DataTestId) => {
  if (member?.valid === false) {
    return (
      <ListItemText
        data-testid={dataTestId}
        primary="Credit removed"
        primaryTextProps={{
          color: 'textError',
        }}
      />
    );
  }
  if (
    member.status === SplitMemberStatus.PROPOSED &&
    member.memberIdentifier === currentUserGuid
  ) {
    return (
      <div data-testid="proposed-split-controls">
        <Button size="sm" onClick={proposeNewSplit} mr={2}>
          New Split
        </Button>
        {split?.valid && (
          <Button size="sm" onClick={acceptSplit}>
            Accept
          </Button>
        )}
      </div>
    );
  }
  if (member.status === SplitMemberStatus.ACCEPTED) {
    return (
      <>
        <Icon as={CheckmarkIcon} color="G.80" width={5} height={5} mr={2} />
        <ListItemText primary="Accepted" data-testid={dataTestId} />
      </>
    );
  }
  return <ListItemText primary="Pending" data-testid={dataTestId} />;
};
